import { render } from "./Illustration.vue?vue&type=template&id=71ec801d&ts=true"
import script from "./Illustration.ts?vue&type=script&lang=ts"
export * from "./Illustration.ts?vue&type=script&lang=ts"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__